<template>
    <div class="container winningNumber_wrap">

        <p class="page_title">번호입력</p>

        <section class="section sec1">
            <div class="sec_titbox">
                <div class="leftbox">
                    <div class="input_box date">
                        <!-- <input type="text" placeholder="날짜 선택" class="input_text datepicker" readonly
                            value="2024-08-01 ~ 2024-08-07"> -->
                    </div>
                </div>
                <div class="rightbox">
                    <div class="select_box">
                        <select class="select" @change="searchRound">
                            <option value="">회차</option>
                            <option v-for="obj in roundList" :key="obj.round" :value="obj.round">{{ obj.round }}
                            </option>
                        </select>
                    </div>
                    <div class="input_box big">
                        <input type="text" placeholder="숫자만 입력하세요." class="input_text search" v-model="search"
                            @keyup="searchDatatables">
                    </div>
                    <button type="button" class="btn ver2 reset_btn" @click="resetSearch">
                        <span class="icon"></span>
                        <span class="txt">초기화</span>
                    </button>
                </div>
            </div>
            <div class="tbl_wrap">
                <DataTable ref="table" :data="winningList" class="tbl" :columns="columns" :options="dtOptions">
                </DataTable>
            </div>
        </section>

        <section class="page_bottom">
            <div class="leftbox"></div>
            <div class="rightbox">
                <button type="button" class="btn" @click="reqShowModal">
                    <span class="txt">등록</span>
                </button>
            </div>
        </section>
    </div>
    <NumberInsertModal :show="showModal" @modalClose="handleModalClose" :isCorrect="isCorrect" :data="winningData" />
    <WinningModal v-if="showWinningModal" :show="showWinningModal" @closeWinningModal="handleWinningModalClose"
        :data="winningData" :rank="rank" />
</template>
<script setup>
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net';
DataTable.use(DataTablesCore);
import NumberInsertModal from "../NumberInsertModal.vue";
import WinningModal from "../WinningModal.vue";
import { ref, onMounted, getCurrentInstance } from "vue";
import { getWinningList } from "../../api";
const showModal = ref(false);
const showWinningModal = ref(false);
const isCorrect = ref(false);
const roundList = ref([]);
const rank = ref(0);
const winningData = ref({
    num_1: 0,
    num_2: 0,
    num_3: 0,
    num_4: 0,
    num_5: 0,
    num_6: 0,
    bonus_num: 0,
    first_winning: 0,
    second_winning: 0,
    third_winning: 0,
    round: 0,
    date: '',
});
const table = ref();


const winningList = ref([]);
const { proxy } = getCurrentInstance();
const reqShowModal = () => {
    showModal.value = true;
    isCorrect.value = false;
    winningData.value = {
        num_1: 0,
        num_2: 0,
        num_3: 0,
        num_4: 0,
        num_5: 0,
        num_6: 0,
        bonus_num: 0,
        first_winning: 0,
        second_winning: 0,
        third_winning: 0,
        round: 0,
        date: '',
    };
}
const handleModalClose = () => {
    showModal.value = false;
}
const handleWinningModalClose = () => {
    showWinningModal.value = false;
}
onMounted(async () => {
    const res = await getWinningList();
    winningList.value = [...res.data.list];
    roundList.value = [...res.data.round];
    console.log(roundList.value);
})


const dtOptions = {
    paging: true,  // 페이지네이션 활성화
    searching: true,  // 검색 활성화
    info: false,
    pageLength: 10,
    lengthChange: false,
    order: [[0, 'desc']],
    language: {
        emptyTable: '데이터가 없습니다.', // 메시지 변경
    },
}


const columns = [
    {
        data: 'round', title: '회차', render: (data) => {
            return `<td class="num">${data}</td>`
        }

    },
    {
        data: 'draw_date', title: '추첨일', render: (data) => {
            const date = new Date(data);
            return `<td class="date">${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}</td>`
        }
    },

    {
        data: 'num_1', title: '당첨 번호', orderable: false, render: (data, type, row) => {
            return `<div class="winning_box">
                                    <div class="winning_item medium">
                                        <div class="winning_ball ${row.num_1 < 10 ? 'color1' : row.num_1 >= 10 && row.num_1 < 20 ? 'color2' : row.num_1 >= 20 && row.num_1 < 30 ? 'color3' : row.num_1 >= 30 && row.num_1 < 40 ? 'color4' : 'color5'}">
                                            <div class="numbox">
                                                <span class="num">${row.num_1}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="winning_item medium">
                                        <div class="winning_ball ${row.num_2 < 10 ? 'color1' : row.num_2 >= 10 && row.num_2 < 20 ? 'color2' : row.num_2 >= 20 && row.num_2 < 30 ? 'color3' : row.num_2 >= 30 && row.num_2 < 40 ? 'color4' : 'color5'}">
                                            <div class="numbox">
                                                <span class="num">${row.num_2}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="winning_item medium">
                                        <div class="winning_ball ${row.num_3 < 10 ? 'color1' : row.num_3 >= 10 && row.num_3 < 20 ? 'color2' : row.num_3 >= 20 && row.num_3 < 30 ? 'color3' : row.num_3 >= 30 && row.num_3 < 40 ? 'color4' : 'color5'}">
                                            <div class="numbox">
                                                <span class="num">${row.num_3}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="winning_item medium">
                                        <div class="winning_ball ${row.num_4 < 10 ? 'color1' : row.num_4 >= 10 && row.num_4 < 20 ? 'color2' : row.num_4 >= 20 && row.num_4 < 30 ? 'color3' : row.num_4 >= 30 && row.num_4 < 40 ? 'color4' : 'color5'}">
                                            <div class="numbox">
                                                <span class="num">${row.num_4}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="winning_item medium">
                                        <div class="winning_ball ${row.num_5 < 10 ? 'color1' : row.num_5 >= 10 && row.num_5 < 20 ? 'color2' : row.num_5 >= 20 && row.num_5 < 30 ? 'color3' : row.num_5 >= 30 && row.num_5 < 40 ? 'color4' : 'color5'}">
                                            <div class="numbox">
                                                <span class="num">${row.num_5}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="winning_item medium">
                                        <div class="winning_ball ${row.num_6 < 10 ? 'color1' : row.num_6 >= 10 && row.num_6 < 20 ? 'color2' : row.num_6 >= 20 && row.num_6 < 30 ? 'color3' : row.num_6 >= 30 && row.num_6 < 40 ? 'color4' : 'color5'}">
                                            <div class="numbox">
                                                <span class="num">${row.num_6}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="winning_plus"></div>
                                    <div class="winning_item medium">
                                        <div class="winning_ball ${row.bonus_num < 10 ? 'color1' : row.bonus_num >= 10 && row.bonus_num < 20 ? 'color2' : row.bonus_num >= 20 && row.bonus_num < 30 ? 'color3' : row.bonus_num >= 30 && row.bonus_num < 40 ? 'color4' : 'color5'}">
                                            <div class="numbox">
                                                <span class="num">${row.bonus_num}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>`
        }
    },
    {
        data: null, title: '수정', orderable: false, render: () => {
            return `<span class="badge_icon edit_btn">
                                        <img src="${proxy.$STATIC_URL}/admin/img/badge_edit.png" alt="" class="icon">
                                        <span class="txt">수정</span>
                                    </span>`
        },
        createdCell: (td, cellData, rowData) => {
            td.querySelector('.edit_btn').addEventListener('click', (event) => {
                event.preventDefault();
                winningData.value = { ...rowData };
                isCorrect.value = true;
                showModal.value = true;
            });
        }
    },
    {
        data: 'first_winning', title: '1등 추출 수', render: (data) => {
            return `<td class="1st">
                        <a href="#none" class="link number_btn">${data}</a>
                    </td>`
        },
        createdCell: (td, cellData, rowData) => {

            td.querySelector('.link').addEventListener('click', (event) => {
                event.preventDefault();
                winningData.value = { ...rowData };
                showWinningModal.value = true;
                rank.value = 1;
            });
        }
    },
    {
        data: 'second_winning', title: '2등 추출 수', render: (data) => {
            return `<td class="2nd">
                        <a href="#none" class="link number_btn">${data}</a>
                    </td>`
        },
        createdCell: (td, cellData, rowData) => {

            td.querySelector('.link').addEventListener('click', (event) => {
                event.preventDefault();
                winningData.value = { ...rowData };
                showWinningModal.value = true;
                rank.value = 2;
            });
        }
    },
    {
        data: 'third_winning', title: '3등 추출 수', render: (data) => {
            return `<td class="3rd">
                        <a href="#none" class="link number_btn">${data}</a>
                    </td>`
        },
        createdCell: (td, cellData, rowData) => {

            td.querySelector('.link').addEventListener('click', (event) => {
                event.preventDefault();
                winningData.value = { ...rowData };
                showWinningModal.value = true;
                rank.value = 3;
            });
        }
    }
];

const search = ref('');
const searchRound = (event) => {
    const dt = table.value.dt;
    dt.search(event.target.value).draw();
}
const searchDatatables = () => {
    const dt = table.value.dt;
    dt.search(search.value).draw();
}

const resetSearch = () => {
    search.value = '';
    const dt = table.value.dt;
    dt.search('').draw();
}
</script>
<style scoped>
:deep(.dt-paging-button) {
    width: 40px;
    height: 40px;
    font-size: 14px;
    line-height: 157%;
    letter-spacing: -0.04em;
    color: var(--color-text);
    border: 1px solid var(--color-border2);
    border-radius: 8px;
    background: var(--color-white);
    overflow: hidden;
    margin: 0 10px;
}

:deep(.dt-paging-button.current) {
    font-weight: 700;
    color: var(--color-white);
    background: var(--color-gradient1);
}

:deep(.dt-paging nav) {
    display: flex;
    justify-content: center;
}

:deep(.dt-paging) {
    margin-top: 20px;
    margin-bottom: 20px;
}

:deep(.dt-search) {
    display: none
}
</style>